import { EditingSpaceModel } from './models/editing-space-model.interface';
import { EditingSpaceModelImpl } from './models/editing-space-model';
export function editingSpaceModule(bind) {
    bind(EditingSpaceModel).to(EditingSpaceModelImpl);
}
